module.exports = __webpack_public_path__ + "static/media/S1_00003.a48fd175.jpg";